import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Chip from '@mui/material/Chip'
import { theme } from '../../themes/theme'
import { FlexWrapRow } from '../styles/Containers'

const StyledChip = styled(Chip)`
  &.MuiChip-root {
    border-radius: ${theme.borderRadius.iconButton};
    background-color: ${theme.colors.background.medium};
    height: auto;
    padding: 5px 0;
  }

  .MuiChip-label {
    color: ${theme.colors.text.body};
    font-family: ${theme.fonts.body};
    font-weight: 500;
    white-space: wrap;
    padding: 0 10px;
  }
`

function ClassificationChips({ items }) {
  return (
    <FlexWrapRow gap="5px">
      {items.map(item => (
        <StyledChip key={item.id} label={item.label} />
      ))}
    </FlexWrapRow>
  )
}

ClassificationChips.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
}

export default ClassificationChips
